import {getAssetInfo, SERVICE_ID, SERVICE_IDS} from "@/common/consts/service.js";

const loadedCss = new Set();

let loadedServiceId;

export function loadServiceCss(serviceId, type) {
    if (!serviceId) {
        alert('There is no serviceId.');
        return;
    }

    serviceId = serviceId.toUpperCase();
    type = type.toUpperCase();

    if (loadedServiceId === serviceId) {
        return;
    }

    loadedCss.forEach(css => css.unuse());
    loadedCss.clear();

    //서비스 아이디가 존재하지 않거나 잘못된 입력된 경우
    if (!serviceId || !SERVICE_IDS.find(id => id === serviceId)) {
        serviceId = SERVICE_ID.EMPTY_SERVICE_ID;
        type = SERVICE_ID.EMPTY_TYPE;
    }

    getAssetInfo(serviceId, type).css.forEach(promise => {
        promise.then(function(css) {
            css.use();
            loadedCss.add(css);
            loadedServiceId = serviceId;
        });
    });
}
